/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useRef } from "react";
import { Editor } from "../../Editor";
import { DialogProvider } from "./Dialogs/DialogProvider";
import { ToastProvider } from "./Toasts/ToastProvider";
import { ErrorBoundary } from "@adapptio/lib-components";
import { ErrorFallback } from "./ErrorFallback";
import { EditorUIContextProvider } from "@adapptio/lib-editor-ui";
import { ReferenceSelectorContextProvider } from "../contexts/ReferenceSelectorContext";

/**
 * Component props
 */
export interface IEditorLoginProps {
	editorInstance: Editor;
}

/**
 *  Editor Login Screen Component
 *
 * @param props Component props
 */
export const EditorLogin: React.FunctionComponent<IEditorLoginProps> = ({ editorInstance }) => {
	const rootElRef = useRef<HTMLDivElement>();

	const dialogService = editorInstance.get("dialogService");
	const toastService = editorInstance.get("toastService");

	return (
		<ErrorBoundary fallback={<ErrorFallback />}>
			<div className="adpt-editor adpt-editor__main" ref={rootElRef}>
				<ReferenceSelectorContextProvider>
					<EditorUIContextProvider rootEl={rootElRef}>
						<DialogProvider dialogService={dialogService} />
						<ToastProvider toastService={toastService} />
					</EditorUIContextProvider>
				</ReferenceSelectorContextProvider>
			</div>
		</ErrorBoundary>
	);
};
